import React from 'react';
export function IssuerHeader() {
  return <div className="min-w-0 text-left" data-id="element-1366">
      <img src="https://cdn.magicpatterns.com/uploads/3HmLapdTMRvTJbmSkdh1g8/Bmedhospital.png" alt="BMED Medical Centre" className="mb-2 h-14 w-14 object-contain" data-id="element-1367" />
      <p className="text-xl font-bold uppercase tracking-wide text-pink-600 sm:text-2xl" data-id="element-1368">
        BMED MEDICAL CENTRE
      </p>
      <p className="mt-0.5 text-xs italic text-slate-600" data-id="element-1369">
        Caring Healing Leading
      </p>
      <address className="mt-3 space-y-0.5 not-italic text-xs leading-5 text-slate-700" data-id="element-1370">
        <p data-id="element-1371">Plot No. 1884/10, Along Avic Road, Lilayi Estate</p>
        <p data-id="element-1372">Kafue, Lusaka - Zambia</p>
        <p data-id="element-1373">Contact: +260975202011</p>
        <p data-id="element-1374">Email: bmedhospital@gmail.com</p>
        <p data-id="element-1375">TPIN:2000869447</p>
      </address>
    </div>;
}